import{styled}from"styled-components";export const Brand=/*#__PURE__*/styled.svg.withConfig({componentId:"sc-1x05f8y-0"})`flex-shrink:0;fill:none;`;
//# sourceMappingURL=brand.styles.js.map